// import {headerWithCredentials, ruleServerUrl} from 'configs/rule-server';
import salesAnalyticsService from '../../../services/sales-analytics-service'
import storeTagsService from '../../../services/store-tags-service'
import campaignService from '../../../services/campaigns-service.js'
import orderCaptureService from '../../../services/order-capture-service'
import userService from '../../../services/user-service'
import {capitalCase as title} from 'change-case'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_STORE_OPTIONS = 'LOAD_STORE_OPTIONS'
export const LOAD_BRAND_OPTIONS = 'LOAD_BRAND_OPTIONS'

export const LOADING_TOTAL_SALES = 'LOADING_TOTAL_SALES'
export const FAILED_LOADING_TOTAL_SALES = 'FAILED_LOADING_TOTAL_SALES'
export const LOADED_TOTAL_SALES = 'LOADED_TOTAL_SALES'

export const LOADING_PRODUCT_SALES_SPLIT = 'LOADING_PRODUCT_SALES_SPLIT'
export const FAILED_LOADING_PRODUCT_SALES_SPLIT = 'FAILED_LOADING_PRODUCT_SALES_SPLIT'
export const LOADED_PRODUCT_SALES_SPLIT = 'LOADED_PRODUCT_SALES_SPLIT'

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

export function loadTotalSales(filter) {
  return dispatch => {
    dispatch({type: LOADING_TOTAL_SALES})
    return salesAnalyticsService.getTotalSales(filter)
      .then(totalSales => {
        if (!totalSales) {
          return dispatch({
            type: FAILED_LOADING_TOTAL_SALES
          })
        }
        return dispatch({
          type: LOADED_TOTAL_SALES,
          totalSales: totalSales
        })
      })
  }
}

export function loadProductSalesSplit(filter) {
  return dispatch => {
    dispatch({type: LOADING_PRODUCT_SALES_SPLIT})
    return salesAnalyticsService.getSalesHierarchySplit(filter)
      .then(salesHierarchySplit => {
        if (!salesHierarchySplit) {
          return dispatch({
            type: LOADING_PRODUCT_SALES_SPLIT
          })
        }
        return dispatch({
          type: LOADED_PRODUCT_SALES_SPLIT,
          productSalesSplit: salesHierarchySplit
        })
      })
  }
}

function dispatchStores(dispatch, stores) {
  let options = stores.map(store => {
    return {
      label: title(store.storeNameAlias || store.store),
      value: store.store,
      isActive: store.isActive,
      tags: _.compact(_.map(store.tags, tag => {
        return {value: tag.value, type: tag.type}
      })), 
      tenantBrandBusinessId: store.tenantBrandBusinessId
    }
  })
  const activeStores = _.filter(options, "isActive");
  const inActiveStores = _.filter(options, function(o) { return !o.isActive });
  const storeOptions = [...activeStores, ...inActiveStores]
  let storeTagOptionsWithGroupName = storeTagsService.getStoreTagOptionsByStoreOptions(storeOptions)
  dispatch({
    type: LOAD_STORE_OPTIONS,
    storeOptions: storeOptions,
    storeTagOptions: storeTagOptionsWithGroupName
  })
}

export function loadStoreOptions() {
  return (dispatch, getState) => {
    return userService.getCurrentUser()
      .then((user) => {
        return _.isEmpty(user.tenant_stores) ? campaignService.getStores() : user.tenant_stores
      })
      .then((stores) => dispatchStores(dispatch, stores))
  }
}

export function loadBrandDetails() {
  return (dispatch, getState) => {
    return orderCaptureService.getUserDetails().then((userDetails) => {
      let brands = userDetails.tenant.brands.map(brand => {
        return {
          brandName: brand.name,
          businessNames: brand.businesses.map(business => business.name),
          businesses: brand.businesses
        }
      })
      dispatch({
        type: LOAD_BRAND_OPTIONS,
        brands
      })
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function totalSalesReducer(state = [], action) {
  switch (action.type) {
    case LOADING_TOTAL_SALES: {
      return {loading: true, salesSplit: null, failed: false}
    }
    case FAILED_LOADING_TOTAL_SALES: {
      return {loading: false, salesSplit: null, failed: true}
    }
    case LOADED_TOTAL_SALES: {
      return {
        loading: false,
        salesSplit: action.totalSales.salesSplit,
        failed: false
      }
    }
    default:
      return state
  }
}

export function productSalesSplitReducer(state = [], action) {
  switch (action.type) {
    case LOADING_PRODUCT_SALES_SPLIT: {
      return {loading: true, data: null, items: null, failed: false}
    }
    case FAILED_LOADING_PRODUCT_SALES_SPLIT: {
      return {loading: false, data: null, items: null, failed: true}
    }
    case LOADED_PRODUCT_SALES_SPLIT: {
      return {
        loading: false,
        data: action.productSalesSplit.data,
        items: action.productSalesSplit.items,
        failed: false
      }
    }
    default:
      return state
  }
}

export function loadStoreOptionsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_STORE_OPTIONS: {
      return action.storeOptions
    }
    default:
      return state
  }
}

export function loadStoreTagOptionsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_STORE_OPTIONS: {
      return action.storeTagOptions
    }
    default:
      return state
  }
}

export function loadBrandNamesReducer(state = [], action) {
  switch (action.type) {
    case LOAD_BRAND_OPTIONS: {
      return action.brands
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/SalesAnalytics/modules/salesAnalytics.js